<template>
  <div id="userinfo" class="userinfo userbox" v-loading.fullscreen="loading">
    <div class="userTitle">Personal information</div>
    <div class="userRightSmallBox">
      <div class="info infoBorder" v-if="!isEditName">
        <div>
          <i @click='showEdit(0)'></i>
          <span>Nickname</span>
          {{userInfo.NickName}}
        </div>
        <div>
          <span>Phone number</span>
          {{userInfo.Mobile}}
        </div>
      </div>
      <div class="info editInfo" v-if="isEditName">
        <div class="editInfoTitle">Change information</div>
        <el-form :model="infoForm" :rules="inforules" ref="infoForm">
          <el-form-item class="info_form_item" prop="NickName">
            <div class="info_title">Nickname</div>
            <el-input class="info_ipt" v-model="infoForm.NickName" placeholder="Please enter a nickname" @input="setInput('NickName')"></el-input>
          </el-form-item>
          <div class="info_btn_between">
            <el-button class="info_btn" @click="resetForm('infoForm')">Cancel</el-button>
            <el-button class="info_btn" :disabled='disabled' type="primary" @click="submitInfoForm('infoForm')">Confirm</el-button>
          </div>
        </el-form>
      </div>
      <div class="info infoBorder" v-if="!isEditPassword">
        <div>
          <i @click='showEdit(1)'></i>
          <span>Change password</span>
          ****************
        </div>
      </div>
      <div class="info editInfo" v-if="isEditPassword">
        <div class="editInfoTitle">Change password</div>
        <el-form :model="passwordForm" :rules="passwordrules" ref="passwordForm">
          <el-form-item class="info_form_item" prop="oldpassword">
            <div class="info_title">Current password</div>
            <el-input class="info_ipt" v-model="passwordForm.oldpassword" :type="flagType" minlength='6' maxlength='20'  placeholder="Please enter your current password" @input="setInput()">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" @click="getFlag()" /></el-input>
          </el-form-item>
          <el-form-item class="info_form_item" prop="newpassword">
            <div class="info_title">New password</div>
            <el-input class="info_ipt" v-model="passwordForm.newpassword" :type="flagType" minlength='6' maxlength='20'  placeholder="Please enter a new password" @input="setInput()">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" @click="getFlag()" /></el-input>
          </el-form-item>
          <el-form-item class="info_form_item" prop="repeatpassword">
            <div class="info_title">Confirm new password</div>
            <el-input class="info_ipt" v-model="passwordForm.repeatpassword" :type="flagType" minlength='6' maxlength='20'  placeholder="Confirm new password" @input="setInput()">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" @click="getFlag()" /></el-input>
          </el-form-item>
          <div class="info_btn_between">
            <el-button class="info_btn" @click="resetForm('passwordForm')">Cancel</el-button>
            <el-button class="info_btn" :disabled='disabled' type="primary" @click="submitPasswordForm('passwordForm')">Confirm</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { isEmoji,getInfo,setInfo,toLogout } from "@/api/public";
export default {
  name: 'userinfo',
  components: {},
  data() {
    var newPassAgain = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Confirm new password'));
      } else if (value !== this.passwordForm.newpassword) {
        callback(new Error('Passwords do not match'));
      } else {
        callback();
      }
    };
    return {
      loading:false,
      userInfo:getInfo(),
      isEditName:false,
      isEditPassword:false,
      disabled:true,
      flagType: 'password',
      flag: false,
      infoForm: {
        NickName: '',
      },
      passwordForm:{
        oldpassword:'',
        newpassword:'',
        repeatpassword:''
      },
      inforules: {
        NickName: [
          { required: true, message: 'Please enter a nickname', trigger: 'blur' },
        ]
      },
      passwordrules: {
        oldpassword: [
          { required: true, message: 'Please enter your current password', trigger: 'blur' },
        ],
        newpassword: [
          { required: true, message: 'Please enter a new password', trigger: 'blur' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{6,20}$/, message: 'Password must be 6-20 characters and contain uppercase, lowercase, numbers, and special characters.',trigger: 'blur'},
        ],
        repeatpassword: [
          { validator: newPassAgain, trigger: 'blur' },
        ]
      },
    }
  },
  mounted() {},
  created() {
    this.GetMemberInfo()
  },
  methods: {
    GetMemberInfo(){
      let that=this;
      that.loading=true;
      let info=getInfo();
      let data={MemberId:info._id}
      that.$get(that.$interface.GetMemberInfoById,data).then(res=>{
        if(res.Result!=0){
          that.userInfo=res.Data;
          //newInfo
          setInfo('Level',res.Data.Level);
          setInfo('PointsAll',res.Data.PointsAll?res.Data.PointsAll:0);
          that.$root.$emit("newInfo",res.Data.Level);
        }else{
          that.$message.error(res.Msg);
        }
        that.loading=false
      }).catch({})
      //console.log('data',data)
    },
    // 显示修改表单  val 0:昵称，1:密码
    showEdit(val){
      if(val==0){
        this.isEditName=true;
        this.isEditPassword=false;
      }else if(val==1){
        this.isEditName=false;
        this.isEditPassword=true;
      }
    },
    // 判断 表单内容是不是全部输入了
    setInput(){
      if(this.isEditName){
        this.infoForm['NickName'] = isEmoji(this.infoForm['NickName'], 1)
        if(this.infoForm.NickName!=''){
          this.disabled=false;
        }else{
          this.disabled=true;
        }
      }else if(this.isEditPassword){
        this.passwordForm['oldpassword'] = isEmoji(this.passwordForm['oldpassword'], 1)
        this.passwordForm['newpassword'] = isEmoji(this.passwordForm['newpassword'], 1)
        this.passwordForm['repeatpassword'] = isEmoji(this.passwordForm['repeatpassword'], 1)
        if(this.passwordForm['oldpassword']!=''&&this.passwordForm['newpassword']!=''&&this.passwordForm['repeatpassword']!=''){
          this.disabled=false;
        }else{
          this.disabled=true;
        }
      }
    },
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password' //text为显示密码；password为隐藏密码
    },
    // 表单提交
    submitInfoForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.disabled=true;
          let data={NickName:that.infoForm.NickName,Id:that.userInfo._id}
          that.$get(that.$interface.UpdateNickName,data).then(res=>{
            if(res.Result!=0){
              that.userInfo.NickName=that.infoForm.NickName;
              setInfo('NickName',that.infoForm.NickName);
              that.$root.$emit("newName");
              that.resetForm(formName);
            }
          }).catch({})
        }
      });
    },
    // 表单提交
    submitPasswordForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.disabled=true;
          let data={mobile:that.userInfo.Mobile,memberId:that.userInfo._id,oldPassword:that.passwordForm.oldpassword,newPassword:that.passwordForm.newpassword}
          that.$post(that.$interface.SignResetPassword,data).then(res=>{
            if(res.Result!=0){
              that.$message.success('Changes saved. Please sign in again.');
              toLogout()
            }else{
              that.$message.error(res.Msg);
            }
          }).catch({})
        }
      });
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.isEditPassword=false;
      this.isEditName=false;
      this.disabled=true;
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/user.css";

</style>



// WEBPACK FOOTER //
// src/pages/user/info.vue